import {
    ApiHandler,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnErrorIsSet
} from "@insite/client-framework/HandlerCreator";
import {
    ApiParameter,
    ServiceResult
} from "@insite/client-framework/Services/ApiService";
import {
    resetPassword as resetPasswordApi,
} from "@stoneage/App/Services/ResetPassword/ResetPasswordService";

export interface ResetPasswordParameter {
    onSuccess?: () => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandler<ResetPasswordParameter, ServiceResult<ApiParameter>>;


export const ResetPassword: HandlerType = async props => {
    props.apiResult = await resetPasswordApi();
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        // markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
    }
};

export const chain = [ResetPassword, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const resetPassword = createHandlerChainRunner(chain, "ResetPassword");
export default resetPassword;
